import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=8dc4f3b4&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=8dc4f3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc4f3b4",
  null
  
)

export default component.exports